import React, { useState } from 'react';

import { useDebouncedValue } from '@mantine/hooks';
import { getMonthRangeDatesMTD } from 'utils/date-functions';

import PackageCategoryRevenuePageHeader from './components/PackageCategoryRevenuePageHeader';
import PackageCategoryRevenueTable from './components/PackageCategoryRevenueTable';
import { SearchFilters } from './types';

const PackageCategoryRevenue = (): JSX.Element => {
  const defaultDates = getMonthRangeDatesMTD();

  const initialSearchFiltersValue: SearchFilters = {
    dateRange: [defaultDates[0], defaultDates[1]],
  };
  const [searchFilters, setSearchFilters] = useState<SearchFilters>(initialSearchFiltersValue);
  const [debouncedSearchFilters] = useDebouncedValue<SearchFilters>(searchFilters, 250);
  const [orderingValue, setOrderingValue] = useState<string>('-revenue');

  return (
    <>
      <PackageCategoryRevenuePageHeader
        initialSearchFiltersValue={initialSearchFiltersValue}
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
        orderingValue={orderingValue}
      />

      <PackageCategoryRevenueTable
        searchFilters={debouncedSearchFilters}
        setOrderingValue={setOrderingValue}
      />
    </>
  );
};

export default PackageCategoryRevenue;
